import { useEffect } from 'react';

function revealInViewport(elements) {
  const vh = window.innerHeight || document.documentElement.clientHeight;
  elements.forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top < vh + 120 && rect.bottom > -80) {
      el.classList.add('is-visible');
    }
  });
}

/**
 * Fade/slide-in landing sections when they enter the viewport.
 * Content stays readable on dark sections (see App.css — no opacity:0 trap).
 */
export function useLandingReveal(active) {
  useEffect(() => {
    if (!active) return undefined;

    let io;
    let fallbackTimer;

    const attach = () => {
      const root = document.querySelector('.lp-main');
      if (!root) return;

      const els = root.querySelectorAll('.lp-reveal');
      if (!els.length) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        els.forEach((el) => el.classList.add('is-visible'));
        return;
      }

      revealInViewport(els);

      io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '120px 0px 120px 0px', threshold: 0.05 }
      );

      els.forEach((el) => {
        if (!el.classList.contains('is-visible')) {
          io.observe(el);
        }
      });

      fallbackTimer = window.setTimeout(() => {
        els.forEach((el) => el.classList.add('is-visible'));
      }, 1800);
    };

    const t = window.requestAnimationFrame(attach);

    return () => {
      window.cancelAnimationFrame(t);
      io?.disconnect();
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
    };
  }, [active]);
}
